import { render, staticRenderFns } from "./AvatarBlock.vue?vue&type=template&id=16b82f6a&scoped=true&"
import script from "./AvatarBlock.vue?vue&type=script&lang=js&"
export * from "./AvatarBlock.vue?vue&type=script&lang=js&"
import style0 from "./AvatarBlock.vue?vue&type=style&index=0&id=16b82f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b82f6a",
  null
  
)

export default component.exports